import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable({
  providedIn: 'root'
})
export class VaccinesService {
  private collection:string = 'vaccinations';
  constructor(
    private afs: AngularFirestore   
  ) { }
  getByUser(user:any){
    return new Promise((resolve)=>{
      let valueChanges = this.afs.collection(this.collection, ref => ref.where('user', '==', String(user).toString())).valueChanges();
      valueChanges.subscribe((result:any)=>{
        resolve(result);
      });
    });
  }
  syncDocRef(docRef:any){
    return this.afs.collection(this.collection).doc(docRef).update({ docRef: docRef });
  }
  getByDoc(doc:any){
    return this.afs.collection(this.collection).doc(doc).valueChanges();
  }
  load(){
    return this.afs.collection(this.collection).valueChanges();
  }
  loadFromPetInfo(petInfo:any){
    console.log(petInfo)
    return new Promise((resolve)=>{
      let valueChanges = this.afs.collection(this.collection, res => res.where('petAge', '==', petInfo.petAge).where('petType', '==', petInfo.petType)).valueChanges();
      valueChanges.subscribe((result:any)=>{
        resolve(result);
      });
    })
  }
  save(model:any){
    return new Promise((resolve, reject)=>{
      this.afs.collection(this.collection).add(model)
      .then((result:any)=>{
        this.syncDocRef(result.id).then(()=>{
          this.getByDoc(result.id).subscribe((pet:any)=>{
            resolve(pet);
          });
        }).catch((error:any)=>{
          reject(error);
        });
      }).catch((error:any)=>{
        reject(error);
      });
    });
  }
  deleteByDocRef(doc:any){
    return new Promise((resolve, reject)=>{
      this.afs.collection(this.collection).doc(doc).delete()
      .then(()=>{
        resolve();
      }).catch((error:any)=>{
        reject(error);
      });
    });
  }
  done(docRef:any){
    return new Promise((resolve, reject)=>{
      let params = {
        done: true
      };
      this.afs.collection(this.collection).doc(docRef).update(params)
      .then(()=>{
        resolve();
      }).catch((error:any)=>{
        reject(error);
      });
    });
  }
}
